// extracted by mini-css-extract-plugin
module.exports = {"container":"src-containers-Form-SimplifiedBuilder-Components-integration___container","iconButton":"src-containers-Form-SimplifiedBuilder-Components-integration___iconButton"};